import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaletteListing from './PaletteListing';

export default class PaletteListingWrapper extends Component {
	static propTypes = {
		paletteService: PropTypes.object.isRequired, // was glass context
		getPalettes: PropTypes.func.isRequired,
		createPalette: PropTypes.func,
		onChange: PropTypes.func.isRequired,
		onClose: PropTypes.func,
		mruComponentIdentifier: PropTypes.string.isRequired, // was component
		selectedId: PropTypes.string,
		createPaletteType: PropTypes.string
	}

	constructor(props) {
		super(props);
		const { selectedId } = this.props;
		this.state = {
			selectedId: selectedId
		};
	}

	render () {
		const { paletteService, getPalettes, createPalette, mruComponentIdentifier, createPaletteType, onClose } = this.props;
		const { selectedId } = this.state;

		return (
			<PaletteListing
				paletteService={paletteService}
				getPalettes={getPalettes}
				createPalette={createPalette}
				onChange={this._onChange.bind(this)}
				mruComponentIdentifier={mruComponentIdentifier}
				selectedId={selectedId}
				createPaletteType={createPaletteType}
				onClose={onClose}
			/>
		);
	}

	_onChange (palette = {}) {
		this.setState({ selectedId: palette.id });
	}
}



// WEBPACK FOOTER //
// ./src/js/components/paletteListing/PaletteListingWrapper.js